import { ReactNode, useLayoutEffect, useRef } from "react";

// Components
import Header from "./header";
import { Box, Grid } from "@mui/material";
import { TagProps } from "@/components/tag";
import { FilterBarProps } from "./filter_bar";


interface _GridListProps<T> {
    data?: T[];
    dataKey?: keyof T;
    filters?: FilterBarProps;
    tags?: TagProps[];
    isLoading?: boolean;
    children: ReactNode;
    onSearchUpdate?: (search: string) => void;
    onReachBottom?: () => void;
    bottomTriggerOffset?: number;
}

const GridList = <T extends object>({
    data = [],
    dataKey,
    filters,
    tags,
    isLoading = false,
    children,
    onSearchUpdate,
    onReachBottom,
    bottomTriggerOffset = 0,
}: _GridListProps<T>) => {

    const gridRef = useRef<HTMLDivElement|null>(null);

    useLayoutEffect(() => {
        const onScroll = () => {
            const rect = gridRef.current?.getBoundingClientRect();
            if (window.innerHeight > (rect!.bottom - bottomTriggerOffset)) {
                onReachBottom?.();
            }
        }

        window.addEventListener('scroll', onScroll);
        return () => window.removeEventListener('scroll', onScroll);
    }, [])

    return (
        <Box ref={gridRef} display="flex" flexDirection="column">

            {/* Filter and search */}
            {filters && <Header filters={filters} tags={tags} onSearchChange={onSearchUpdate} />}

            {/* Grid */}
            <Grid container spacing={2}> 
                {children}
            </Grid>
        </Box>
    )
}

export default GridList;